import { CardTypeEnum } from '@colonist/game-states';
import { ModeSettingEnum } from '@colonist/types';
export function getBankCardStackSize(modeSetting, cardType, cardCount) {
    const stackLimits = getCardStackLimits(modeSetting, cardType);
    return getStackSize(cardCount, stackLimits);
}
export function getBankCardStackCountRange(modeSetting, cardType, cardCount) {
    if (cardCount === 0) return {
        lowerBound: 0,
        upperBound: 0
    };
    const stackSize = getBankCardStackSize(modeSetting, cardType, cardCount);
    const stackLimits = getCardStackLimits(modeSetting, cardType);
    return {
        lowerBound: stackLimits[stackSize - 1] + 1,
        upperBound: stackLimits[stackSize]
    };
}
function getStackSize(amountOfCards, stackLimits) {
    if (amountOfCards == stackLimits[0]) return 0;
    if (amountOfCards <= stackLimits[1]) return 1;
    if (amountOfCards <= stackLimits[2]) return 2;
    return 3;
}
function getCardStackLimits(modeSetting, cardType) {
    switch(cardType){
        case CardTypeEnum.Resource:
            return getResourceCardStackLimits(modeSetting);
        case CardTypeEnum.Commodity:
            return getCommodityCardStackLimits(modeSetting);
        case CardTypeEnum.Development:
            return getDevelopmentCardStackLimits(modeSetting);
        case CardTypeEnum.ProgressPolitics:
        case CardTypeEnum.ProgressScience:
        case CardTypeEnum.ProgressTrade:
            return getResourceCardStackLimits(modeSetting);
        default:
            return [
                0,
                0,
                0,
                0
            ];
    }
}
function getResourceCardStackLimits(modeSetting) {
    switch(modeSetting){
        case ModeSettingEnum.Classic4P:
        case ModeSettingEnum.Seafarers4P:
        case ModeSettingEnum.CitiesAndKnights4P:
        case ModeSettingEnum.CitiesAndKnightsSeafarers4P:
            return [
                0,
                7,
                13,
                19
            ];
        case ModeSettingEnum.Classic56P:
        case ModeSettingEnum.Seafarers56P:
        case ModeSettingEnum.CitiesAndKnights56P:
        case ModeSettingEnum.CitiesAndKnightsSeafarers56P:
            return [
                0,
                8,
                16,
                24
            ];
        case ModeSettingEnum.Classic78P:
            return [
                0,
                10,
                20,
                29
            ];
        default:
            return [
                0,
                7,
                13,
                19
            ];
    }
}
function getCommodityCardStackLimits(modeSetting) {
    switch(modeSetting){
        case ModeSettingEnum.Classic4P:
        case ModeSettingEnum.Seafarers4P:
        case ModeSettingEnum.CitiesAndKnights4P:
        case ModeSettingEnum.CitiesAndKnightsSeafarers4P:
            return [
                0,
                4,
                8,
                12
            ];
        case ModeSettingEnum.Classic56P:
        case ModeSettingEnum.Seafarers56P:
        case ModeSettingEnum.CitiesAndKnights56P:
        case ModeSettingEnum.CitiesAndKnightsSeafarers56P:
            return [
                0,
                6,
                12,
                18
            ];
        case ModeSettingEnum.Classic78P:
            return [
                0,
                8,
                16,
                24
            ];
        default:
            return [
                0,
                4,
                8,
                12
            ];
    }
}
function getDevelopmentCardStackLimits(modeSetting) {
    switch(modeSetting){
        case ModeSettingEnum.Classic4P:
        case ModeSettingEnum.Seafarers4P:
        case ModeSettingEnum.CitiesAndKnights4P:
        case ModeSettingEnum.CitiesAndKnightsSeafarers4P:
            return [
                0,
                9,
                17,
                25
            ];
        case ModeSettingEnum.Classic56P:
        case ModeSettingEnum.Seafarers56P:
        case ModeSettingEnum.CitiesAndKnights56P:
        case ModeSettingEnum.CitiesAndKnightsSeafarers56P:
            return [
                0,
                12,
                23,
                34
            ];
        case ModeSettingEnum.Classic78P:
            return [
                0,
                15,
                29,
                43
            ];
        default:
            return [
                0,
                9,
                17,
                25
            ];
    }
}
